// Instrument catalog — the bundled snapshot of the instruments picker's family grouping and the
// 1:1 instrument→sample mapping. The DATA lives in the canonical suggestionTaxonomy.json (served
// by Rails so content edits ship without an extension rebuild); this module re-exports the
// instrumentation slice with its types so existing importers (suggestionInfo grouping,
// sampleExamples audio resolution) are unchanged.
//
// `value` is the canonical instrument name (what resolveSampleKey/groupSuggestions match on).
// `key` is the instrument's OWN sample key — a clip lives at /audio/samples/<key>.mp3 once
// generated (see AVAILABLE_SAMPLE_KEYS in sampleExamples.ts). `desc` is an OPTIONAL one-liner.
//
// The flat list of `value`s is mirrored by PromptHints::Library::INSTRUMENT_POOL (Ruby).
import taxonomy from './suggestionTaxonomy.json'

export interface InstrumentEntry {
  value: string
  key: string
  desc?: string
}

export interface InstrumentFamily {
  key: string
  label: string
  entries: InstrumentEntry[]
}

export const INSTRUMENT_FAMILIES: InstrumentFamily[] = taxonomy.instrumentation.families as InstrumentFamily[]
